import { UIStore } from './ui'
import { UserStore } from './user'
import { TaxRegistrationStore } from './tax-registration'
import { SessionStore } from './session'
import { AuditStore } from './audit'
import { ImportLibraryStore } from './import-library-store'
import { TaxCodesStore } from './tax-codes'
import { LayoutStore } from './layout-store'
import { FmsStores } from './fms-stores'
import { BoxSummaryStore } from './box-summary'
import { AdminStore } from './admin'
import { AdjustmentListStore } from './adjustment-list'
import { TransactionAdjustmentStore } from './transaction-adjustment'
import { AdhocAdustmentStore } from './adhoc-adjustment'
import { AdustmentStore } from './adjustment-modal'
import { ImportPartsStore } from './import-parts'
import { WorkflowStore } from './workflow'
import { ToleranceStore } from './tolerance'
import { NewAdjustmentStore } from './new-adjustment-store'
import { ObligationsStore } from './obligations'
import { GettingStartedWizardStore } from './getting-started-wizard'
import { ProvisionerStore } from './provisioner'

let stores = null

function getStores () {
  return {
    uiStore: new UIStore(),
    sessionStore: new SessionStore(),
    userStore: new UserStore(),
    provisionerStore: new ProvisionerStore(),
    taxRegistrationStore: new TaxRegistrationStore(),
    auditStore: new AuditStore(),
    importLibraryStore: new ImportLibraryStore(),
    taxCodesStore: new TaxCodesStore(),
    layoutStore: new LayoutStore(),
    fmsStores: new FmsStores(),
    boxSummaryStore: new BoxSummaryStore(),
    adminStore: new AdminStore(),
    adjustmentListStore: new AdjustmentListStore(),
    transactionAdjustmentStore: new TransactionAdjustmentStore(),
    AdhocAdustmentStore: new AdhocAdustmentStore(),
    AdustmentStore: new AdustmentStore(),
    importPartsStore: new ImportPartsStore(),
    workflowStore: new WorkflowStore(),
    toleranceStore: new ToleranceStore(),
    newAdjustmentStore: new NewAdjustmentStore(),
    obligationsStore: new ObligationsStore(),
    gettingStartedWizardStore: new GettingStartedWizardStore()
  }
}

export function initialiseStores (isServer) {
  if (isServer) {
    return getStores()
  } else {
    if (!stores) {
      stores = getStores()
    }
  }
  return stores
}
